import * as z from 'zod'

import { api } from '../../utils/api'

const InputSchema = z.tuple([z.object({
	username: z.string().nonempty(),
	password: z.string().nonempty()
})])

const OutputSchema = z.promise(z.any())

const FunctionSchema = z.function(InputSchema, OutputSchema)

export const DoLogin = FunctionSchema.implement(async ({ username, password }) => await api.post(`/user/login`, { username, password }))